import { Grid } from '@mui/material';
import DetailsCardSkeleton from './details-card';
import ActivityCardSkeleton from './activity-card';

const ContactOverviewSkeleton = () => {
    return (
        <Grid container spacing={2}>
            <DetailsCardSkeleton />
            <ActivityCardSkeleton />
        </Grid>
    );
};

export default ContactOverviewSkeleton;
